<template>
    <div class="content-card mb-4">
        <div class="content-card-title">ยกเลิกแล้ว</div>
        <div class="content-card-body">
            <h2 class="mb-0">{{ qtyCancel }}</h2>
            <small class="text-medium d-block mb-2">ท่านสามารถยกเลิกได้ 5 ครั้งต่อวัน</small>
            <strong class="text-dark d-block">วันนี้ยกเลิกไปแล้วทั้งหมด <span class="text-success">{{qtyCancel  }} /10</span>
                ครั้ง</strong>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    qtyCancel: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      link: ''

    }
  },
  created () {

  },
  methods: {

  },
  computed: {

  },
  watch: {

  },
  mounted () {
    console.log('Component mounted!')
  }
}
</script>
